<template>
  <div class="ui large modal">
    <div class="ui inverted dimmer" v-bind:class="{ active: processing }">
      <div class="ui text double slow blue loader">{{ $t("loading") }}</div>
    </div>
    <i class="close icon"></i>
    <div class="icon header">
      <i class="eye icon"></i>
      {{ $t("instance tracker") }}
    </div>
    <div class="content">
      <div class="canvas" style="height: 600px" id="js-canvas"></div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";

import BpmnModeler from "bpmn-js/lib/Modeler";
import "bpmn-js/dist/assets/diagram-js.css";
import "bpmn-js/dist/assets/bpmn-font/css/bpmn.css";

export default {
  components: {},
  computed: {},
  data() {
    return {
      processing: false,
      instance: undefined,
      modeler: undefined
    };
  },
  props: {
    instance_id: String
  },
  methods: {
    highlight(element) {
      let vm = this;
      var modeling = vm.modeler.get("modeling");
      let _stroke = [undefined, "#000", "#000000"].includes(
        element.businessObject.di.stroke
      )
        ? "#55ACEE"
        : "#000";
      let _fill = [undefined, "#000", "#000000"].includes(
        element.businessObject.di.fill
      )
        ? "#F7F7F7"
        : "#FFF";
      modeling.setColor(element, {
        stroke: _stroke,
        fill: _fill
      });
    }
  },
  mounted() {
    let vm = this;
    local_api(this, "post", "/ngine_workspace/worklist/do-get-tracking-info", {
      u: vm.instance_id
    })
      .then(instance => {
        vm.modeler = new BpmnModeler({
          container: "#js-canvas"
        });

        let setup = JSON.parse(instance.ngn_process.setup);

        vm.modeler
          .importXML(setup.setup.xml)
          .then(() => {
            var canvas = vm.modeler.get("canvas");
            canvas.zoom("fit-viewport");

            window.jQuery(".djs-palette").remove();

            let time = 500;
            window.jQuery.each(instance.ngn_interactions, function(i, v) {
              setTimeout(function() {
                let cmpnt = JSON.parse(v.component);
                var elementRegistry = vm.modeler.get("elementRegistry");
                var elem = elementRegistry.get(cmpnt.id);
                vm.highlight(elem);
              }, time);
              time += 500;
            });
          })
          .catch(err => {
            console.error(err);
          });
      })
      .catch(err => {
        error_toast(err);
      });

    vm.modal = window
      .jQuery(vm.$el)
      .modal({
        onShow() {},
        onVisible() {},
        onHidden() {
          vm.$emit("destroy");
          vm.$destroy();
        }
      })
      .modal("show");
  },
  watch: {},
  updated: function() {}
};
</script>
